import type { FC, ReactNode } from 'react';

interface TMSFiledCardProps {
  title: string;
  children: ReactNode;
  labelClass?: string;
  containerClass?: string;
  isRequired?: boolean;
  isSingleLine?: boolean;
  labelForTestId?: string;
}

const TMSFiledCard: FC<TMSFiledCardProps> = ({
  title,
  children,
  labelClass = '',
  containerClass = '',
  isRequired,
  isSingleLine,
  labelForTestId,
}) => {
  return (
    <div
      className={`field-card-container ${containerClass} ${isSingleLine ? 'd-flex align-items-center' : ''}`}
      data-testid={labelForTestId ? labelForTestId : ''}
    >
      <p className={`field-card-title lh-16 mt-0 mb-2 mx-0 ${labelClass} ${isRequired ? 'fw-800 f-14' : ''} `}>
        {title}
        {isRequired ? <span className="ml-2 pt-5 text-iconDanger fw-800 f-18">*</span> : <></>}
      </p>
      <div className="content fw-600 f-14">{children}</div>
    </div>
  );
};

export default TMSFiledCard;
